<!-- Toast global para erros HTTP interceptados (http-error.interceptor.ts) -->
<p-toast position="top-right"></p-toast>

<!-- Rota do Cardapio Digital (layout isolado, nao depende do booting) -->
<ng-container *ngIf="isCardapioRoute">
  <router-outlet></router-outlet>
</ng-container>

<!-- Layout do ERP -->
<ng-container *ngIf="!isCardapioRoute">
  <!-- Loader full-screen ENQUANTO inicializa -->
  <div *ngIf="booting" class="boot-overlay">
    <p-progressSpinner strokeWidth="4"></p-progressSpinner>
  </div>

  <!-- App apos inicializar -->
  <ng-container *ngIf="!booting">
    <app-header *ngIf="isAuthenticated"></app-header>

    <div class="app-body" [class.app-body--authenticated]="isAuthenticated">
      <app-menu-lateral
        *ngIf="isAuthenticated"
        (sidebarStateChange)="onSidebarStateChange($event)">
      </app-menu-lateral>

      <div [class.sidebar-active]="isAuthenticated" class="content" style="flex: 1; min-height: 0; overflow: auto; overflow-x: hidden;">
        <router-outlet></router-outlet>
        <app-modal></app-modal>
      </div>
    </div>

    <!-- Dialog global de cotacao (funciona em qualquer pagina) -->
    <app-cotacao-dialog
      *ngIf="isAuthenticated"
      [(visivel)]="dialogCotacaoVisivel"
      [empresaId]="dialogCotacaoEmpresaId ?? empresaId"
      [moedaEmpresa]="dialogCotacaoMoedaEmpresa"
      [subtituloChave]="dialogCotacaoSubtituloChave"
      (cotacaoSalva)="onCotacaoSalva()"
      (cancelado)="onCotacaoSalva()">
    </app-cotacao-dialog>

    <!-- Dialog global de notificacao de novo pedido (funciona em qualquer pagina) -->
    <app-notificacao-pedido-dialog
      *ngIf="isAuthenticated"
      [visivel]="dialogNotificacaoVisivel"
      [notificacao]="notificacaoAtual"
      [texts]="{
        titulo: textsNotificacao.titulo,
        pedido_numero: notificacaoAtual ? (translate.instant('notificacao_pedido.texts.pedido_numero', { codigo: notificacaoAtual.codigoDePedido })) : '',
        cliente: textsNotificacao.cliente,
        estado: textsNotificacao.estado,
        ver_pedido: textsNotificacao.ver_pedido,
        fechar: textsNotificacao.fechar
      }"
      (visivelChange)="dialogNotificacaoVisivel = $event"
      (verPedido)="onVerPedidoNotificacaoGlobal($event)">
    </app-notificacao-pedido-dialog>
  </ng-container>
</ng-container>
